var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7015 3.01635C8.70182 2.96151 8.69131 2.90715 8.67058 2.85639C8.64984 2.80562 8.61929 2.75945 8.58067 2.72051L6.814 0.953848C6.77507 0.915231 6.7289 0.884679 6.67813 0.863943C6.62737 0.843208 6.57301 0.832698 6.51817 0.833015C6.46334 0.832698 6.40898 0.843208 6.35821 0.863943C6.30744 0.884679 6.26127 0.915231 6.22234 0.953848L5.04317 2.13301L0.489004 6.68718C0.450387 6.72611 0.419835 6.77229 0.3991 6.82305C0.378364 6.87382 0.367854 6.92818 0.368171 6.98301V8.74968C0.368171 8.86019 0.41207 8.96617 0.49021 9.04431C0.56835 9.12245 0.674331 9.16635 0.784838 9.16635H2.5515C2.60981 9.16952 2.66813 9.1604 2.72268 9.13958C2.77723 9.11877 2.8268 9.08672 2.86817 9.04551L7.39734 4.49135L8.58067 3.33301C8.6187 3.29263 8.64969 3.24615 8.67234 3.19551C8.67635 3.1623 8.67635 3.12873 8.67234 3.09551C8.67429 3.07612 8.67429 3.05658 8.67234 3.03718L8.7015 3.01635ZM2.38067 8.33301H1.2015V7.15385L5.339 3.01635L6.51817 4.19551L2.38067 8.33301ZM7.10567 3.60801L5.92651 2.42885L6.51817 1.84135L7.69317 3.01635L7.10567 3.60801Z",
    fill: "#1C1C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.4a0821c6148fbd774dee1cca9b162752.svg";
export { ForwardRef as ReactComponent };